import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import ContributiiImg from "../images/contributii-img.png";
import search from "../images/search-icon.png";

import "../css/main.css";

const Contributii = () => {
  return (
    <div>
      <Header />

      <div className="contributii">
        <div className="container">
          <div className="row">
            <div className=" grid-2">
              <div className="item">
                <div className="image">
                  <div className="date">
                    <div className="day">12</div>
                    <div className="month">SEP</div>
                  </div>
                  <img src={ContributiiImg} alt="contributii " />
                </div>
                <div className="content">
                  <h2>Armonie între Minte și Emoții</h2>
                  <p>
                    Un eveniment dedicat explorării echilibrului emoțional și
                    sănătății mentale. Prin workshop-uri interactive, discuții
                    cu specialiști și tehnici practice, vei descoperi cum să-ți
                    gestionezi stresul, să-ți îmbunătățești relațiile și să-ți
                    regăsești armonia interioară....
                  </p>
                  <a href="/" className="see-more">
                    Vezi detalii
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="image">
                  <div className="date">
                    <div className="day">12</div>
                    <div className="month">SEP</div>
                  </div>
                  <img src={ContributiiImg} alt="contributii imagine" />
                </div>
                <div className="content">
                  <h2>Armonie între Minte și Emoții</h2>
                  <p>
                    Un eveniment dedicat explorării echilibrului emoțional și
                    sănătății mentale. Prin workshop-uri interactive, discuții
                    cu specialiști și tehnici practice, vei descoperi cum să-ți
                    gestionezi stresul, să-ți îmbunătățești relațiile și să-ți
                    regăsești armonia interioară....
                  </p>
                  <a href="/" className="see-more">
                    Vezi detalii
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="image">
                  <div className="date">
                    <div className="day">12</div>
                    <div className="month">SEP</div>
                  </div>
                  <img src={ContributiiImg} alt="contributii " />
                </div>
                <div className="content">
                  <h2>Armonie între Minte și Emoții</h2>
                  <p>
                    Un eveniment dedicat explorării echilibrului emoțional și
                    sănătății mentale. Prin workshop-uri interactive, discuții
                    cu specialiști și tehnici practice, vei descoperi cum să-ți
                    gestionezi stresul, să-ți îmbunătățești relațiile și să-ți
                    regăsești armonia interioară....
                  </p>
                  <a href="/" className="see-more">
                    Vezi detalii
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="image">
                  <div className="date">
                    <div className="day">12</div>
                    <div className="month">SEP</div>
                  </div>
                  <img src={ContributiiImg} alt="contributii " />
                </div>
                <div className="content">
                  <h2>Armonie între Minte și Emoții</h2>
                  <p>
                    Un eveniment dedicat explorării echilibrului emoțional și
                    sănătății mentale. Prin workshop-uri interactive, discuții
                    cu specialiști și tehnici practice, vei descoperi cum să-ți
                    gestionezi stresul, să-ți îmbunătățești relațiile și să-ți
                    regăsești armonia interioară....
                  </p>
                  <a href="/" className="see-more">
                    Vezi detalii
                  </a>
                </div>
              </div>
            </div>
            <div className="column aside">
              <div className="search-container">
                <form action="">
                  <input type="text" placeholder="Caută un eveniment" />
                  <div className="search-icon">
                    <input type="submit" value="" />
                    <img src={search} alt="icon search" />
                  </div>
                </form>
              </div>
              <div className="recent-posts">
                <h2>Postări recente</h2>
                <div className="post">
                  <div className="image">
                    <img src={ContributiiImg} alt="contributii" />
                  </div>
                  <div className="column">
                    <div className="date">12 sep, 2025</div>
                    <div className="title">Armonie între Minte și Emoții</div>
                  </div>
                </div>
                <div className="post">
                  <div className="image">
                    <img src={ContributiiImg} alt="contributii" />
                  </div>
                  <div className="column">
                    <div className="date">12 sep, 2025</div>
                    <div className="title">Armonie între Minte și Emoții</div>
                  </div>
                </div>
                <div className="post">
                  <div className="image">
                    <img src={ContributiiImg} alt="contributii" />
                  </div>
                  <div className="column">
                    <div className="date">12 sep, 2025</div>
                    <div className="title">Armonie între Minte și Emoții</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contributii;
